// THIRD - PARTY IMPORT
import { forwardRef } from "react";
import { Controller } from "react-hook-form";
import DropDown from "../DropDown/DropDown";

const ControlledDropDown = forwardRef((props, ref) => {
    const { control, name, ...rest } = props;

    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { ref: _, onChange, ...restt } }) => {
                return <DropDown {...restt} onChange={(e, option) => onChange?.(e?.value, option)} {...rest} ref={ref} />;
            }}
        />
    );
});

export default ControlledDropDown;
